import { AI_AGREEMENT_URL } from '@/consts/aiAgreement';
import { useTranslation } from '@/i18n';
import { TextLink } from '@moneyforward/ap-frontend-components';
import { FC } from 'react';

export const AiAgreementLink: FC = () => {
  const { t } = useTranslation();

  return (
    <TextLink href={AI_AGREEMENT_URL} target='_blank'>
      {t('ai_service_setting.agreement_link')}
    </TextLink>
  );
};
